import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "ss_admin_token";

// Attach bearer token to every request if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getFighters = () => api.get("/fighters").then((r) => r.data);
export const getEvents = () => api.get("/events").then((r) => r.data);
export const getContent = () => api.get("/content").then((r) => r.data);
export const subscribe = (email, captchaToken) => api.post("/subscribe", {
  email,
  captcha_token: captchaToken,
  captcha_action: "newsletter_subscribe",
}).then((r) => r.data);
export const sendContact = (payload, captchaToken, captchaAction = "contact_form") => api.post("/contact", {
  ...payload,
  captcha_token: captchaToken,
  captcha_action: captchaAction,
}).then((r) => r.data);

// Admin — Events
export const adminCreateEvent = (payload, h) => api.post("/admin/events", payload, { headers: h }).then((r) => r.data);
export const adminUpdateEvent = (id, payload, h) => api.put(`/admin/events/${id}`, payload, { headers: h }).then((r) => r.data);
export const adminUpdateEventEnquiry = (id, enquiry, h) => api.put(`/admin/events/${id}/enquiry`, { enquiry }, { headers: h }).then((r) => r.data);
export const adminDeleteEvent = (id, h) => api.delete(`/admin/events/${id}`, { headers: h }).then((r) => r.data);

// Admin — Fighters
export const adminCreateFighter = (payload, h) => api.post("/admin/fighters", payload, { headers: h }).then((r) => r.data);
export const adminUpdateFighter = (id, payload, h) => api.put(`/admin/fighters/${id}`, payload, { headers: h }).then((r) => r.data);
export const adminDeleteFighter = (id, h) => api.delete(`/admin/fighters/${id}`, { headers: h }).then((r) => r.data);

// Admin — Content
export const adminGetContent = (h) => api.get("/admin/content", { headers: h }).then((r) => r.data);
export const adminCreatePageSection = (payload, h) => api.post("/admin/page-sections", payload, { headers: h }).then((r) => r.data);
export const adminUpdatePageSection = (id, payload, h) => api.put(`/admin/page-sections/${id}`, payload, { headers: h }).then((r) => r.data);
export const adminDeletePageSection = (id, h) => api.delete(`/admin/page-sections/${id}`, { headers: h }).then((r) => r.data);

export const adminCreateSponsor = (payload, h) => api.post("/admin/sponsors", payload, { headers: h }).then((r) => r.data);
export const adminUpdateSponsor = (id, payload, h) => api.put(`/admin/sponsors/${id}`, payload, { headers: h }).then((r) => r.data);
export const adminDeleteSponsor = (id, h) => api.delete(`/admin/sponsors/${id}`, { headers: h }).then((r) => r.data);

export const adminCreateTeamMember = (payload, h) => api.post("/admin/team-members", payload, { headers: h }).then((r) => r.data);
export const adminUpdateTeamMember = (id, payload, h) => api.put(`/admin/team-members/${id}`, payload, { headers: h }).then((r) => r.data);
export const adminDeleteTeamMember = (id, h) => api.delete(`/admin/team-members/${id}`, { headers: h }).then((r) => r.data);

export const adminUploadImage = (file, folder = "general", h = {}) => {
  const form = new FormData();
  form.append("image", file);
  form.append("folder", folder);
  return api.post("/admin/uploads/images", form, { headers: h }).then((r) => r.data);
};

export const adminDeleteImage = (image, h = {}) =>
  api.delete("/admin/uploads/images", { headers: h, data: { image } }).then((r) => r.data);

// Admin — Lists
export const adminGetSubscribers = (h) => api.get("/admin/subscribers", { headers: h }).then((r) => r.data);
export const adminGetMessages = (h) => api.get("/admin/messages", { headers: h }).then((r) => r.data);

// Auth
export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

export const formatError = (e, fallback = "Something went wrong.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");

  const errors = e?.response?.data?.errors;
  if (errors && typeof errors === "object") {
    return Object.values(errors).flat().join(" ");
  }

  return fallback;
};
